import React, { } from "react";
import { colors, fonts } from "../../Styles";

interface UnitProps {
  content: string
  glyph?: JSX.Element
  color: string
  focusView?: boolean
}

export default function UNIT({content, glyph, color = colors.greyPrimary, focusView = false}:UnitProps) {

  return(
    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "2px" }}>
      {glyph}
      <p style={{ ...fonts.header, ...(focusView ? fonts.fontSize3 : fonts.fontSize4), color: color}}>{content}</p>
    </div>
  )
}